import { Injectable } from '@angular/core';

import * as Bowser from 'bowser';

@Injectable({
  providedIn: 'root',
})
export class UserAgentService {
  getBrowser(): string {
    const browser = Bowser.getParser(window.navigator.userAgent);
    return browser.getBrowserName() + '-' + browser.getBrowserVersion();
  }

  getOS(): string {
    const browser = Bowser.getParser(window.navigator.userAgent);
    return browser.getOSName() + '-' + browser.getOSVersion();
  }

  getTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
